import actionConstants from '../constants/';

const defaultState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
};

const planListState = {
  ...defaultState,
};

const createPlanState = {
  ...defaultState,
  isUpdate: false,
};

const deletePlanState = {
  ...defaultState,
};

const searchPlanByNameList = {
  ...defaultState,
};

const initialState = {
  planListState: { ...planListState },
  createPlanState: { ...createPlanState },
  deletePlanState: { ...deletePlanState },
  searchPlanByNameList: { ...searchPlanByNameList },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function planReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_PLANS_LIST_REQUEST:
      return {
        ...state,
        planListState: {
          ...state.planListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PLANS_LIST_SUCCESS:
      return {
        ...state,
        planListState: {
          ...state.planListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload?.body?.plans || [],
          totalElements: action.payload?.body?.page?.total_elements || 0,
        },
      };

    case actionConstants.GET_PLANS_LIST_FAILURE:
      return {
        ...state,
        planListState: {
          ...state.planListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: [],
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.error_details?.error?.message || action.payload.body?.message,
        },
      };

    case actionConstants.GET_PLANS_LIST_CLEAR:
      return {
        ...state,
        planListState,
      };

    case actionConstants.SEARCH_PLANS_BY_NAME_REQUEST:
      return {
        ...state,
        searchPlanByNameList: {
          ...state.searchPlanByNameList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.SEARCH_PLANS_BY_NAME_SUCCESS:
      return {
        ...state,
        searchPlanByNameList: {
          ...state.searchPlanByNameList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.SEARCH_PLANS_BY_NAME_FAILURE:
      return {
        ...state,
        searchPlanByNameList: {
          ...state.searchPlanByNameList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.error_details?.error?.message || action.payload.body?.message,
        },
      };
    case actionConstants.SEARCH_PLANS_BY_NAME_CLEAR:
      return {
        ...state,
        searchPlanByNameList,
      };

    case actionConstants.POST_CREATE_UPDATE_PLAN_REQUEST:
      return {
        ...state,
        createPlanState: {
          ...state.createPlanState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
          isUpdate: false,
        },
      };

    case actionConstants.POST_CREATE_PLAN_SUCCESS:
      return {
        ...state,
        createPlanState: {
          ...state.createPlanState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isUpdate: false,
        },
      };

    case actionConstants.PATCH_UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        createPlanState: {
          ...state.createPlanState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          isUpdate: true,
        },
      };

    case actionConstants.POST_CREATE_UPDATE_PLAN_FAILURE:
      return {
        ...state,
        createPlanState: {
          ...state.createPlanState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.error_details?.error?.message || action.payload.body?.message,
        },
      };

    case actionConstants.POST_CREATE_UPDATE_PLAN_CLEAR:
      return {
        ...state,
        createPlanState,
      };

    case actionConstants.DELETE_PLAN_REQUEST:
      return {
        ...state,
        deletePlanState: {
          ...state.deletePlanState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.DELETE_PLAN_SUCCESS:
      return {
        ...state,
        deletePlanState: {
          ...state.deletePlanState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
        },
      };

    case actionConstants.DELETE_PLAN_FAILURE:
      return {
        ...state,
        deletePlanState: {
          ...state.deletePlanState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body?.code,
          errorMessage: action.payload.body?.error_details?.error?.message || action.payload.body?.message,
        },
      };

    case actionConstants.DELETE_PLAN_CLEAR:
      return {
        ...state,
        deletePlanState,
      };

    default:
      return state;
  }
}
